module.exports = {
    category: [
        { value: 'SLOT', text: 'Slot'},
        { value: 'ARCADE', text: 'Arcade'},
        { value: 'FISHING', text: 'Fishing'},
        { value: 'FAST', text: 'Fast'}
    ],
    volatility: [
        { value: 'Low', text: 'Low'},
        { value: 'Medium', text: 'Medium'},
        { value: 'High', text: 'High'}
    ],
    platform: [
        { value: 'android', text: 'Android', icon: '<i class="lab la-android"></i>' },
        { value: 'ios', text: 'iOS', icon: '<i class="lab la-apple"></i>' },
        { value: 'web', text: 'Web', icon: '<i class="las la-desktop"></i>' }
    ],
    language: [
        { value: 'en_US', text: 'en_US' },
        { value: 'zh_CN', text: 'zh_CN' },
        { value: 'id_ID', text: 'id_ID' },
        { value: 'th_TH', text: 'th_TH' },
        { value: 'vi_VN', text: 'vi_VN' },
        { value: 'ko_KR', text: 'ko_KR' }
    ],
    newsCategory: [
        { value: 'SLOT', text: 'Slot'},
        { value: 'ARCADE', text: 'Arcade'},
        { value: 'FISHING', text: 'Fishing'},
        { value: 'FAST', text: 'Fast'}

    ],
    newsType:[
        { value: 'NEW', text: 'New'},
        { value: 'PROMO', text: 'Promotion'},
    ],
    countdown: [
        { value: 'yes', text: 'Yes'},
        { value: 'no', text: 'No'},
    ],
}